import { useNostoApi } from './useNostoApi';

/**
 * Sends page viewed action to the Nosto.
 */
export function useNostoOtherPage() {
  useNostoApi((api) => {
    // eslint-disable-next-line prettier/prettier
    return api
              .defaultSession()
              .viewOther()
              .setPlacements(api.placements.getPlacements())
              .load();
  }, 'OTHER');
}
